import * as colors from "../../../../common/helpers/colors";

export const toTitleCase = (phrase) => {
  if (!phrase) {
    return null;
  }
  return phrase
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getLevelColor = (level) => {
  if (level === "High") {
    return colors.pathogenicStrongColor;
  }
  if (level === "Medium") {
    return colors.uncertainColor;
  }
  if (level === "Low") {
    return colors.benignStrongColor;
  }
  return colors.defaultPathogenicityColor;
};

export const getRiskLevel = (cells) => {
  if (cells.find((el) => el.risk === "High")) {
    return "High";
  }
  if (cells.find((el) => el.risk === "Medium")) {
    return "Medium";
  }
  if (cells.find((el) => el.risk === "Low")) {
    return "Low";
  }
  return "Not Detected";
};
